export default "__VITE_ASSET__0806a431__"